import { noop, size } from "lodash";
import React, { useEffect } from "react";
import CookieBannerContent from "../CookieBannerContent";
import useSaveCookieSettings from "../../hooks/useSaveCookieSettings";
import { CookiePreferences } from "@/libs/schema/user";
import { Country } from "@/libs/geo/countries";
import { useCurrentUser } from "@/libs/apis/onboarding/useUser";
import CookieModal from "nvs-design-system/dist/Modals/CookieModal";

import { isCountryASupportedEMEACountry } from "../../helpers";

type Props = {
  country: Country;
  open: boolean; // This prop is to allow user to change their preferences
  setOpen: (open: boolean) => void;
  className?: string;
};

const CookieBanner: React.FC<Props> = ({
  country,
  open,
  setOpen,
  className,
}) => {
  const { cookieSettings, setCookieSettings } = useSaveCookieSettings(country);
  const { currentUser } = useCurrentUser();

  useEffect(() => {
    if (cookieSettings === null && size(currentUser?.cookiePreferences) == 0) {
      if (isCountryASupportedEMEACountry(country)) {
        setOpen(true);
      }
    }
  }, [cookieSettings, country, currentUser, setOpen]);

  return (
    //Cannot close modal until preferences are selected, onClose is required
    <CookieModal isOpen={open} className={className}>
      <CookieBannerContent
        onAccept={(cookiePrefs: CookiePreferences) => {
          setCookieSettings(cookiePrefs);
          setOpen(false);
        }}
        cookieSettings={cookieSettings}
      />
    </CookieModal>
  );
};
export default CookieBanner;
